// Centralized brand constants.
import { BACKEND_ORIGIN, API_BASE } from "./apiBase";

export const BRAND = {
  name: "FicoPilot",
  tagline: "The Global Gaming Assistant",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_pilot-gaming-hub/artifacts/wy19r611_3AA32CCB-D3AE-4966-AA8F-F78E3977C651.png",
  neon: "#00E5FF",
};

export const BACKEND_URL = BACKEND_ORIGIN;
export const API = API_BASE;
